function a11y() {
  this.gforms = document.querySelectorAll(".gform_wrapper");
  this.page = document.getElementById('page');

  this.createSkipToMain = () => {
    const skipToMainWrapper = document.createElement("div");
    skipToMainWrapper.classList.add("skip-to-main", "skip-to-main--wrapper");

    const skipToMain = document.createElement("a");
    skipToMain.setAttribute("type", "button");
    skipToMain.setAttribute("href", "#page");
    skipToMain.setAttribute("aria-label", "Skip to main content");
    skipToMain.classList.add("skip-to-main", "skip-to-main--button", "c-btn", "c-btn--primary");
    skipToMain.textContent = "Skip to main content";
    
    skipToMain.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.blur();
      this.page.tabIndex = 0;
      this.page.focus();
      this.page.tabIndex = -1;
    });

    skipToMainWrapper.appendChild(skipToMain);
    document.body.insertBefore(skipToMainWrapper, document.body.firstChild);
  }

  this.gformLabelFixer = (gforms) => {
    if (gforms) {
      gforms.forEach((gform) => {
        const gformLabels = gform.querySelectorAll("label");
        gformLabels.forEach((gformLabel) => {
          if (getComputedStyle(gformLabel).display === "none") {
            gformLabel.style.display = "block";
            gformLabel.classList.add('sr-only');
          }
        });
      });
    }
  }

  this.init = () => {
    this.createSkipToMain();
    this.gformLabelFixer(this.gforms);
  }

  return this;
}

export default new a11y();
